<template>
<div>
    <div class="header">
        <h1 class="page_title">歡迎使用 iCare3+1</h1>
    </div>
    <div class="container">
        <div class="card-hold">
            <div class="c-card">
                <div class="circle-box">
                    <div class="circle"></div>
                    <div class="circle-1"></div>

                </div>
                <div class="c-content color">
                    <div class="col-md-10 mx-auto w">
                        <h2>頁面載入中請稍後2</h2>
                        <h3 style="margin-top:10px; color:#df43779d; font-weight: bold;">載入過程中會有轉跳，請不要關閉本頁面，謝謝。</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footers></footers>
</div>
</template>
<script>
import { Footers } from '@f/layout'
import { mapGetters } from 'vuex'
export default {
    components: {
        Footers
    },
    data(){
        return {
            
        }
    },
    created() {
        console.log(this.lineID)
    },
    mounted() {
        
    },
    computed: {
        ...mapGetters([
            'lineID', 'token', 'avatar', 'lineName'
        ]),
    },
    methods:{
        
    }
}
</script>